import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HeaderLayout from '../../../../components/Layout/Header/HeaderLayout';
import SimulatorResultFunds from '../../../../components/simulator/SimulatorResultFunds';
import ModalErrorFetch from '../../../../components/UI/ModalErrorFetch';
import { InvestmentContext } from '../../../../context/InvestmentContext';
import useModal from '../../../../hooks/custom/useModal';
import useGetSimulatorList from '../../../../hooks/useGetSimulatorList';
import { onRefresh } from '../../../../utils/refreshPage';
import { getFirstElement } from '../../../../utils/utils';
import Spinner from '../../../../components/Spinner';

const FundsResult = () => {
  const [userNotOB, setUserNotOB] = useState(false);
  const { isShowing, toggle } = useModal();
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const [localStorageLoaded, setLocalStorageLoaded] = useState(false);
  const securitySelected = useSelector(state => state.simulation.securitySelected);

  const { setSend, formData, setFormData, resetFormData, clearStorage } =
    useContext(InvestmentContext);

  // service to simulate data funds
  const [
    doGetSimulatorList,
    { data: dataSimulationFunds, error: errorSimulationFunds, loading: loadingSimulationFunds },
  ] = useGetSimulatorList();

  const successGetSimulatorList = dataSimulationFunds?.getInvestmentSimulation;

  const dataResultSimulation = successGetSimulatorList?.simulationData || [];

  const custom = JSON.parse(securitySelected.Custom);
  const motivations = getFirstElement(custom?.preferences.motivaciones);
  const interests = getFirstElement(custom?.preferences.intereses);
  const motivationsId = custom?.preferences.motivaciones[0].id;
  const risk = custom?.preferences.riesgo.description;
  const interestsId = custom?.preferences.intereses[0].id;

  const fileAs = {
    currency: custom.fund_details.currency,
    fileAs: 'FileAsName',
    fileAsComplete: securitySelected?.Name?.slice(4),
    risk: risk,
    motivation: motivations?.split('-')[0],
    motivationId: motivationsId,
    interests: interests,
    interestsId: interestsId,
    products: true,
    profit: securitySelected?.profit,
  };

  const yearsToMonths = {
    '6 meses': 6,
    '1 año': 12,
    '2 años': 24,
    '3 años': 36,
    '5 años': 60,
  };

  const handleInvesment = () => {
    if (!userNotOB) {
      return navigate('/completeregistration');
    }
    if (userNotOB) {
      navigate(`/simulator/investment/${securitySelected.ID}`);
    }
  };

  const handleSubmit = values => {
    clearStorage();

    localStorage.setItem('fundsSimulationData', JSON.stringify(values));

    setFormData(values);

    doGetSimulatorList({
      variables: {
        data: {
          ...values,
          securityId: securitySelected.ID,
          initialInvestment: Number.parseInt(values.initialInvestment?.replace(/\D/g, '')),
          monthlyInvestment: Number.parseInt(values.monthlyInvestment?.replace(/\D/g, ''))
            ? Number.parseInt(values.monthlyInvestment?.replace(/\D/g, ''))
            : 0,
          months: yearsToMonths[values.months],
        },
      },
    });

    setSend(true);
  };

  useEffect(() => {
    const savedData = localStorage.getItem('fundsSimulationData');
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
    setLocalStorageLoaded(true); //ya tenemos los datos listos
  }, [setFormData]);

  useEffect(() => {
    if (securitySelected?.ID && formData?.initialInvestment) {
      const payload = {
        ...formData,
        securityId: securitySelected.ID,
        initialInvestment: Number.parseInt(formData.initialInvestment?.replace(/\D/g, '')),
        monthlyInvestment: Number.parseInt(formData.monthlyInvestment?.replace(/\D/g, '')) || 0,
        months: yearsToMonths[formData.months] || 12,
      };
      doGetSimulatorList({ variables: { data: payload } });
    }
  }, [securitySelected, formData, doGetSimulatorList]);

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setUserNotOB(true);
    }
  }, [user]);

  if (!localStorageLoaded || loadingSimulationFunds) {
    return <Spinner />;
  }

  if (errorSimulationFunds) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorSimulationFunds}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  return (
    <>
      <HeaderLayout mode='funds' type='product' fileAs={fileAs} />
      <SimulatorResultFunds
        formData={formData}
        handleSubmit={handleSubmit}
        handleInvesment={handleInvesment}
        dataResultSimulation={dataResultSimulation}
        setFormData={setFormData}
        securitySelected={securitySelected}
        resetFormData={resetFormData}
        loadingSimulationFunds={loadingSimulationFunds}
      />
    </>
  );
};

export default FundsResult;
